module.exports = __webpack_public_path__ + "media/images/proof_links/colored/hbo-27e4acff99bfe7145a82ab25d9e7e9d6.svg";